import React from 'react';

import PropTypes from 'prop-types';

import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { DiskButton } from 'apps/auth/components/common/DiskButton/DiskButton';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { Text } from 'apps/auth/components/common/Text/Text';
import { MATCHED, NOT_MATCHED } from 'apps/auth/constants/Constants';

import PreCheckRow from './PreCheckRow';

const getIconName = (codeMatched, codeNotMatched) => {
    let iconName;
    if (codeMatched) {
        iconName = 'check-rounded';
    } else if (codeNotMatched) {
        iconName = 'cross-rounded';
    } else {
        iconName = 'info-rounded';
    }
    return iconName;
};

const PreCheckRecipient = (props) => {
    const {
        preCheck: { nameTo },
        paymentForm: { recipientComment = '' },
        code = '',
        messages,
    } = props;
    const statusNotMatched = code === NOT_MATCHED;
    const statusMatched = code === MATCHED;

    const renderWithIcon = (
        <Text variant="span" size="secondary" color={statusNotMatched ? 'error' : 'primary'}>
            {nameTo}
            <DiskButton
                type="button"
                variant={statusNotMatched ? 'errorHint' : 'tertiary'}
                iconName={getIconName(statusMatched, statusNotMatched)}
                iconColor={statusNotMatched ? 'error' : 'primary'}
                size="small"
                marginRight="-8px"
                marginTop="-4px"
                raised={false}
            />
        </Text>
    );
    const renderWithoutIcon = <>{nameTo}</>;

    const getText = (text) => {
        return <DangerouslyHtml dangerouslyHtml={text} />;
    };
    const popup = (
        <SimplePopup text={getText(recipientComment)} handleClose={props.closeHandlerForPopup}>
            <PopupButton
                iconName="check"
                text={messages.gotItButton}
                onClick={(e) => {
                    e.preventDefault();
                    props.closeHandlerForPopup();
                }}
            />
        </SimplePopup>
    );

    const onClickHandler = () => {
        if (recipientComment) {
            props.popupRef?.current?.open(popup);
        }
    };

    return <PreCheckRow title={props.chequeRecipientHeader} text={recipientComment ? renderWithIcon : renderWithoutIcon} onClick={onClickHandler} />;
};
PreCheckRecipient.propTypes = {
    preCheck: PropTypes.object,
    paymentForm: PropTypes.object,
    closeHandlerForPopup: PropTypes.func,
    code: PropTypes.string,
    popupRef: PropTypes.shape({ current: PropTypes.object }),
};
export default PreCheckRecipient;
